import { ForgotPasswordContainer } from '@/features/auth';

export default function ForgotPasswordPage() {
  return <ForgotPasswordContainer />;
}
